// extracted by mini-css-extract-plugin
export default {"overlay":"Preloader_overlay__7lq0s","loader":"Preloader_loader__sHwmp","rotation":"Preloader_rotation__aed9v"};